import React from 'react';
import { Heading } from './heading';

interface SectionHeaderProps {
  headerText: string;
  icon?: React.ReactNode;
  className?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  headerText,
  icon = null,
  className = '',
}) => {
  return (
    <div
      className={`tw:flex tw:!items-center tw:space-x-2 tw:mb-6 tw:dark:text-brand-green-1 ${className}`}
    >
      {icon}
      <Heading level={2}>{headerText}</Heading>
    </div>
  );
};
